import React from "react";

import Container from "@mui/material/Container";

// React Router
import { Navigate, Route, Routes } from "react-router-dom";

// Components
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

// MUI
import Box from "@mui/material/Box";

// Global CSS
import "./assets/style/style.css";

// Containers
import FormGI from "./containers/FormGI";
import Home from "./containers/Home";
import Sobre from "./containers/Sobre";
import Login from "./containers/Login";
import Admin from "./containers/Admin";
import Perfil from "./containers/Perfil";
import Cadastro from "./containers/Cadastro";
import MeusResultados from "./containers/MeusResultados";
import ResultadoList from "./components/ResultadoList";
import RedefinirSenha from "./containers/RedefinirSenha";

// Redux
import { useSelector } from "react-redux";
import {
	selectIsAdmin,
	selectIsAuthenticated,
} from "./storeConfig/reducers/loginReducer";

function App() {
	const isAdmin = useSelector(selectIsAdmin);
	const isAuthenticated = useSelector(selectIsAuthenticated);

	const hours = 1;
	const now = new Date().getTime();
	const setupTime = localStorage.getItem("setupTime");
	if (setupTime !== null) {
		if (now - setupTime > hours * 60 * 60 * 1000) {
			localStorage.clear();
			window.location = "/";
		}
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100vh",
			}}
		>
			<NavBar />

			<Container maxWidth={false} className="mb-5" disableGutters={true}>
				<Routes>
					<Route path="/" element={<Home />} />

					{isAuthenticated && (
						<Route path="/form" element={<FormGI />} />
					)}

					{isAdmin && isAuthenticated && (
						<Route
							path="admin/resultado/:id/"
							element={<ResultadoList />}
						/>
					)}

					<Route path="login/" element={<Login />} />
					<Route path="cadastre-se/" element={<Cadastro />} />
					<Route path="sobre/" element={<Sobre />} />

					{isAdmin && isAuthenticated && (
						<Route path="admin/" element={<Admin />} />
					)}

					
					{isAuthenticated && (
						<Route path="perfil/" element={<Perfil />} />
					)}

					{isAuthenticated && (
						<Route
							path="meus-resultados/"
							element={<MeusResultados />}
						/>
					)}

					{isAuthenticated && (
						<Route
							path="meus-resultados/resultado/:id/"
							element={<ResultadoList />}
						/>
					)}

					<Route
						path="/password/reset/confirm/:uid/:token/"
						element={<RedefinirSenha />}
					/>

					<Route path="*" element={<Navigate to="/" />} />
				</Routes>
			</Container>

			<Footer />
		</Box>
	);
}

export default App;
